import BankIdLogo from "../bankId/BankID_logo.svg?react";

const BankIdIcon = ({ width }) => {
  return <BankIdLogo width={width} />;
};

export default BankIdIcon;
